import { render, staticRenderFns } from "./website-classroom.vue?vue&type=template&id=50990aa9&scoped=true"
import script from "./website-classroom.vue?vue&type=script&lang=js"
export * from "./website-classroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50990aa9",
  null
  
)

export default component.exports